import PhotoBooth from "../components/socialWall/PhotoBoothLink";
import SocialWallMessage from "../components/socialWall/SocialWallMessage";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useCollectionData} from "react-firebase-hooks/firestore";
import {socialWallRef} from "../config/firebaseConfig";
import {ItemStatuses, ItemTypes} from "../constants";
import SocialWallMessageModal from "../components/socialWall/SocialWallMessageModal";
import ThankYouModal from "../components/ThankYouModal";
import {clearTransparentBackground} from "../helpers/img/clearBackground";
import SocialWallItem from "../components/socialWall/SocialWallItem";


function SocialWallPage({users}) {
    const [width, setWidth] = React.useState(window.innerWidth * 0.6);
    const [fontSize, setFontSize] = React.useState(window.innerWidth > 900 ? 36 : window.innerWidth * 0.02);
    const [showAddMessageDialog, setShowAddMessageDialog] = useState(false);
    const [showModerateMessageDialog, setShowModerateMessageDialog] = useState(false);

    const [socialWallData] = useCollectionData(socialWallRef.orderBy('timestamp', 'desc'), {idField: 'id'})

    const approvedData = useMemo(() =>
            socialWallData ? socialWallData.filter(_ => _.status === ItemStatuses.APPROVED) : null,
        [socialWallData])
    // const approvedPhotos = useMemo(() =>
    //         approvedData ? approvedData.filter(_ => _.type === ItemTypes.PHOTO) : null,
    //     [approvedData])
    // const approvedMessages = useMemo(() =>
    //         approvedData ? approvedData.filter(_ => _.type === ItemTypes.MESSAGE) : null,
    //     [approvedData])

    React.useEffect(() => {
        function handleResize() {
            if (window.innerWidth > 900) {
                setWidth(window.innerWidth * 0.6)
                setFontSize(window.innerWidth * 0.02)
            } else {
                setWidth(window.innerWidth * 0.6)
                setFontSize(window.innerWidth * 0.01)
            }
        }

        window.addEventListener('resize', handleResize)
    });

    const styles = {
        pageContainer: {
            margin: '0 16.5vw 30px 16.5vw',
            display: "flex"
        },
        addMsgButton: {
            background: 'transparent',
            color: 'white',
            border: '2px solid #86765c',
            cursor: 'pointer',
            fontSize: '1.0vw',
            fontFamily: 'DINPRO-Bold',
            padding: '0.2vw 1.1vw'
        },
        dialogButton: {}
    }

    const approvedDataWithAuthor = useMemo(() => {
        if (!users || !approvedData)
            return null;
        return approvedData.map(item => ({
            ...item,
            author: users.find(u => u.CustID === item.userId)
        }))
    }, [approvedData, users])


    return (
        <div id="bg" className="social-wall" style={{marginTop: '1.1vw'}}>
            <div className="social-wall-container" style={styles.pageContainer}>
                <SocialWallMessageModal showAddMessageDialog={showAddMessageDialog}
                                        setShowAddMessageDialog={setShowAddMessageDialog}
                                        setShowModerateMessageDialog={setShowModerateMessageDialog}
                />
                <ThankYouModal modalIsOpen={showModerateMessageDialog}
                               handleCloseModal={() => setShowModerateMessageDialog(false)}
                               title="Social Wall Message"
                               body="Thank you. All messages will be moderated before being displayed."
                />
                <div className="social-wall-first-row">
                    <PhotoBooth/>
                    <button onClick={() => setShowAddMessageDialog(true)} style={styles.addMsgButton}>
                        Post a message to the Social Wall here!
                    </button>
                </div>
                <div>
                </div>
                <div className="social-wall-photos custom-scrollbar" style={{height: '60vh'}}>
                    <div className="photoGallery">
                        {!!approvedDataWithAuthor && approvedDataWithAuthor.map(item =>
                            <SocialWallItem key={item.id} item={item}/>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SocialWallPage;
